import { CoaCardProps } from "../CoaCard";
import { getCoaSelectionKey } from '../CoaCard/CoaCard';

interface CoaSelectionTabProps {
    selectedCoa: CoaCardProps | null;
    activeCoas: CoaCardProps[];
    onSelectCoa: (coa: CoaCardProps) => void;
}

function CoaSelectionTabBar({ selectedCoa, activeCoas, onSelectCoa }: CoaSelectionTabProps) {
    
    const handleSelectCoa = (coa: CoaCardProps) => {
        onSelectCoa(coa);
    }

    return (
        <div>
        <div className="coa-selection-tabbar" data-testid="coa-results-tab-list">
            {activeCoas.map((coa, index) => (
            
                <CoaSelectionTab 
                    key={getCoaSelectionKey(coa) || index}
                    coa={coa}
                    index={index + 1}
                    isSelected={Boolean(selectedCoa && getCoaSelectionKey(selectedCoa) === getCoaSelectionKey(coa))}
                    onSelect={handleSelectCoa}
                />
            
            ))}
        </div>
        </div>
    );
}

function CoaSelectionTab({coa, isSelected,index,  onSelect}: {coa: CoaCardProps, isSelected: boolean, index: number, onSelect: (coa: CoaCardProps) => void}) {
    return (
        <div 
            className={`coa-selection-tab ${isSelected ? 'selected' : ''}`} 
            onClick={() => onSelect(coa)}
            data-testid={`coa-results-tab-${coa.id}`}
            data-selected={isSelected}
        >
            <div className="coa-selection-tab-content">
                <div className="coa-selection-tab-label">
                    COA {index}
                </div>
                <div className="coa-selection-tab-subtext">
                   ({coa.date})
                </div>
            </div>
        </div>
    );
}

export default CoaSelectionTabBar;
